<template>
  <div class="FeedbackBannerCard">
    <div class="artwork">
      <slot name="icon" />
    </div>
    <div class="content">
      <p class="title"><slot name="title" /></p>
      <p class="description"><slot name="description" /></p>
      <div class="cta"><slot name="cta" /></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeedbackBannerCard',
}
</script>
<style lang="scss">
.FeedbackBannerCard {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;
  background: $color-feedback-info-light;
  border-radius: 12px;

  & > .artwork {
    min-width: 48px;
    width: 48px;
    height: 48px;
    background: $color-white-low;
    border-radius: 10000px;
    display: flex;
    align-items: center;
    justify-content: center;

    & > svg {
      path {
        fill: $color-black-high;
        fill-opacity: 1;
      }
    }
  }

  & > .content {
    & > .title {
      @include subtitle-2;
      color: $color-black-high;
      margin: 0 0 8px 0;
    }

    & > .description {
      @include body-2;
      color: $color-black-high;
    }

    & > .cta {
      margin: 12px 0 0 0;

      & > .Button {
        background-color: transparent;
      }

      &:empty {
        margin: 0;
      }
    }
  }
}
</style>
